import {
  Paper,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  TableContainer,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { RHFNumberText } from '@/components/forms/hook-form/rhf-number-field';
import { MilestoneStatusLabel } from '@/components/core/milestone-status-label';
import { ChoicesStatusMilestone } from '@/types';
import { CancellationMilestoneDto } from '@/services/cancellation.service';

interface BilledMilestonesTableProps {
  milestones: CancellationMilestoneDto[];
}

export const BilledMilestonesTable = ({ milestones }: BilledMilestonesTableProps) => {
  const { t } = useTranslation();

  if (!milestones || milestones.length === 0) {
    return null;
  }

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{
          '& .MuiTableRow-root:nth-of-type(even)': {
            backgroundColor: 'background.neutral',
          },
          '& .MuiTableRow-root:nth-of-type(odd)': {
            backgroundColor: 'background.neutral',
          },
          '& .MuiTableCell-root': {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '30px',
            color: 'text.primary',
            borderBottom: '1px solid',
            borderBottomColor: 'divider',
          },
          '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
            borderBottom: 'none',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>{t('Milestone')}</TableCell>
            <TableCell>{t('Date')}</TableCell>
            <TableCell>{t('Amount')}</TableCell>
            <TableCell>{t('State')}</TableCell>
            <TableCell>{t('NIIF 15')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {milestones.map((milestone) => (
            <TableRow key={milestone._id}>
              <TableCell>{`${t('Billing Milestone ')} ${milestone.period}`}</TableCell>
              <TableCell
                sx={{
                  color: 'text.secondary',
                  lineHeight: '24px !important',
                  fontWeight: '400 !important',
                  fontSize: '14px !important',
                }}
              >
                {moment(milestone.date).utc().format('L')}
              </TableCell>
              <TableCell>
                <RHFNumberText
                  value={milestone.amount}
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="$ "
                />
              </TableCell>
              <TableCell>
                <MilestoneStatusLabel status={milestone.status as ChoicesStatusMilestone} />
              </TableCell>
              <TableCell>
                <Typography
                  sx={{
                    color: milestone.isNiif15 ? 'success.main' : 'text.secondary',
                    fontSize: '15px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '24px',
                  }}
                >
                  {milestone.isNiif15 ? t('Yes') : t('No')}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
